<form #form="ngForm">
  <townip-modal heading="IP Portfolio - Select a Company" (onHide)="clear()">
    <townip-modal-body>
      <p>Please select a company to access the IP Portfolio.</p>
      <div class="form-group standard-control">
        <label>Client</label>
        <townip-dropdown
          name="selectedCompany"
          class="standard-control"
          placeholder="Please select a client"
          [(ngModel)]="selectedCompany"
          [filter]="true"
          required>
          <townip-option
            *ngFor="let company of companies"
            [label]="company.companyName"
            [value]="company">
          </townip-option>
        </townip-dropdown>
      </div>
    </townip-modal-body>
    <townip-modal-footer>
      <button class="btn btn-secondary" (click)="cancel()">Cancel</button>
      <button class="btn btn-primary" (click)="continue(form)">Continue</button>
    </townip-modal-footer>
  </townip-modal>
</form>
